var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"botao"},[_c('button',{on:{"click":function($event){return _vm.voltar()}}},[_c('i',{staticClass:"fas fa-arrow-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }